import { useEffect, useState } from "react";
import { ShieldCheck, Loader2, LogOut } from "lucide-react";

// Popup bloccante: informativa privacy da accettare al primo accesso e a ogni nuova versione.
export default function PrivacyGate({ client, base = "/gdpr", onLogout }) {
  const [st, setSt] = useState(null);
  const [letto, setLetto] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const load = () => { client.get(`${base}/stato`).then(({ data }) => setSt(data)).catch(() => {}); };
  useEffect(() => { load(); }, [base]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!st || st.accettata) return null;
  const accetta = async () => {
    setBusy(true); setErr("");
    try { await client.post(`${base}/accetta`, { versione: st.versione }); setSt({ ...st, accettata: true }); }
    catch (e) { setErr(e.response?.data?.detail || "Operazione non riuscita, riprova"); if (e.response?.status === 409) { setLetto(false); load(); } }
    finally { setBusy(false); }
  };
  return (
    <div className="fixed inset-0 z-[200] bg-black/70 backdrop-blur-sm grid place-items-center p-3" data-testid="privacy-gate">
      <div className="w-full max-w-2xl max-h-[92vh] flex flex-col rounded-xl shadow-2xl border" style={{ background: "#ffffff", color: "#1e293b", borderColor: "#e2e8f0" }}>
        <div className="flex items-center gap-2 px-5 py-4 border-b" style={{ borderColor: "#e2e8f0" }}>
          <ShieldCheck className="h-5 w-5 text-emerald-500" />
          <h2 className="font-head font-bold text-lg" style={{ color: "#0f172a" }}>Informativa sulla privacy</h2>
          <span className="ml-auto text-xs font-mono" style={{ color: "#64748b" }} data-testid="privacy-gate-versione">versione {st.versione}</span>
        </div>
        <div className="flex-1 overflow-y-auto px-5 py-4 text-sm leading-relaxed whitespace-pre-wrap" style={{ color: "#334155" }} data-testid="privacy-gate-testo">{st.testo}</div>
        <div className="px-5 py-4 border-t space-y-3" style={{ borderColor: "#e2e8f0" }}>
          <label className="flex items-start gap-2 text-sm cursor-pointer" style={{ color: "#1e293b" }}>
            <input type="checkbox" checked={letto} onChange={(e) => setLetto(e.target.checked)} className="mt-0.5 h-4 w-4 accent-emerald-600" data-testid="privacy-gate-check" />
            Dichiaro di aver letto l'informativa e acconsento al trattamento dei miei dati personali per le finalità indicate.
          </label>
          {err && <div className="text-sm text-red-500" data-testid="privacy-gate-error">{err}</div>}
          <div className="flex flex-wrap items-center justify-end gap-2">
            {onLogout && (
              <button type="button" onClick={onLogout} data-testid="privacy-gate-logout" className="inline-flex items-center gap-1.5 px-3 py-2 rounded-md text-sm hover:bg-slate-100" style={{ color: "#475569" }}>
                <LogOut className="h-4 w-4" /> Esci
              </button>
            )}
            <button type="button" disabled={!letto || busy} onClick={accetta} data-testid="privacy-gate-accetta"
              className="inline-flex items-center gap-1.5 px-4 py-2 rounded-md text-sm font-semibold bg-emerald-600 text-white hover:bg-emerald-500 disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
              {busy && <Loader2 className="h-4 w-4 animate-spin" />} Accetto e procedo
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
